import React from 'react';
import classNames from 'classnames';
import { getCoverKey } from 'application/components/utils';
import { TEXTS } from 'application/pages/PointsPage/renderer/texts';
import styles from '../index.module.scss';

interface Props {
  link?: string | null;
  title?: string | null;
  uploading?: boolean;
  className?: string;
}

const MAX_DEFAULT_COVERS_COUNT = 4;
const DISABLED_COVER_INDEX = '3';

const VideoMediafilePosterContent: React.FC<Props> = ({ link, title, uploading, className }) => {
  if (!link) {
    return (
      <div
        className={classNames(styles.Poster, className)}
        data-hash={
          uploading
            ? DISABLED_COVER_INDEX
            : getCoverKey(title || TEXTS.VIDEO_STREAM_INFO_TITLE, MAX_DEFAULT_COVERS_COUNT)
        }
      />
    );
  }

  return (
    <img
      src={link}
      alt=""
      loading="lazy"
      className={classNames(styles.Poster, className)}
    />
  );
};

export default VideoMediafilePosterContent;
